import React from 'react';
import * as S from './InfoCard.styles';

const __cancellation_policy__ = 'Cancellation Policy';
const __exclusion__ = 'Not Included In This Bookings';

import ListingBlock from '../ListingBlock/ListingBlock';

const ThankYouBody = ({cancellationPolicies, exclusions}) => {
  if (!cancellationPolicies.length && !exclusions.length) {
    return null;
  }
  return (
    <S.ThankYouWrap>
      {(cancellationPolicies && cancellationPolicies.length && <ListingBlock listData={cancellationPolicies} title={__cancellation_policy__} />) || null}
      {(exclusions && exclusions.length && <ListingBlock listData={exclusions} title={__exclusion__} />) || null}
    </S.ThankYouWrap>
  );
};

export default ThankYouBody;
